import request from "@/axios.js";

export default class GSC {

    constructor(ps) {
    }
    /**
     * Get list of keywords for a domain
     * @param {String} domain 
     * @param {Number} location_code 
     * @returns 
     */
    static getQueries(url, id){
        return new Promise((resolve, reject) => {
            request.get(
                `/gsc/queries?siteurl=${url}&id=${id}`
            )
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        }	);

    }
    static getOverview(url, id){
        return new Promise((resolve, reject) => {
            request.get(
                `/gsc/overview?siteurl=${url}&id=${id}`
            )
                .then(res => {
                    resolve(res.data);
                })
                .catch(err => {
                    reject(err);
                });
        }	);

    }
    
    
}
